import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/variables.css'
import './styles/global.css'
import './styles/landing.css'
// Logger centralizado: suprime console.log en producción para no-admins.
// Este import debe ser el primero para ejecutar el override desde el inicio.
import './utils/logger.js'
// Aplicar tamaño de texto guardado
import { getTextSize, applyTextSize } from './utils/textSize';
applyTextSize(getTextSize());

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    if (import.meta.env.DEV) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(registration => registration.unregister()));
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.filter(key => key.startsWith('vortex-shell-cache')).map(key => caches.delete(key)));
      }
      return;
    }

    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .then(registration => {
        console.log('SW registrado con éxito:', registration.scope);
      })
      .catch(error => {
        console.log('Fallo en registro de SW:', error);
      });
  });
}